import { takeEvery } from 'redux-saga'

import { apiErrorsSaga } from './error-handling-sagas'

export function* apiErrorsWatcher() {
  yield* takeEvery('*', apiErrorsSaga)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/errors/error-handling-watchers.js
 **/